/*
 * @Author: changcheng
 * @LastEditTime: 2023-04-20 09:43:24
 */
import React, { useEffect, FC, useState } from "react";
import { connect } from "react-redux";
import axios from "@/axios/axios";
import { message, Avatar, Pagination, Card, Breadcrumb } from "antd";
import Header from "@/components/header/index";
import "./index.less";
import * as actions from "@/store/actions";
import { Link } from "react-router-dom";
const { Meta } = Card;
const ExpertDemeanorList: FC<any> = ({ history, setUserInfo }) => {
  // 教师列表
  const [teacherList, setTeacherList] = useState([] as any);
  const [page, setPage] = useState({
    currentPage: 1,
    totalResultSize: 1,
  });
  const getTeacher = async (currentPage: number) => {
    const { code, data, msg }: any = await axios.post(
      "/shop/front/ce/item/teacher/list",
      { currentPage: currentPage, pageSize: 12 }
    );
    if (code === 0) {
      const {
        page: { currentPage, totalResultSize },
      } = data;
      setTeacherList(data.itemTeacherList || []);
      setPage({
        currentPage,
        totalResultSize,
      });
    } else {
      message.error(msg);
    }
  };
  useEffect(() => {
    getTeacher(1);
  }, []);
  const onChange = (currentPage: any) => {
    setPage({
      ...page,
      currentPage,
    });
    getTeacher(currentPage);
  };
  return (
    <div>
      <div className="nav-container">
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to="/index/home">首页</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>专家风采</Breadcrumb.Item>
        </Breadcrumb>
      </div>
      <div className={"teacher-expert-list"}>
        {teacherList.map((item: any, i: number) => (
          <Card
            hoverable
            style={{ width: 240 }}
            cover={
              <img alt="example" src={item.imageAllPath} className="head" />
            }
            onClick={() => {
              history.push(`/index/demeanorInfo?id=${item.id}`);
            }}
          >
            <Meta title={item.name} description={item.workUnit} />
          </Card>
        ))}
      </div>
      <div
        style={{
          textAlign: "center",
        }}
      >
        <Pagination
          showSizeChanger={false}
          current={page.currentPage}
          pageSize={12}
          total={page.totalResultSize}
          onChange={onChange}
        />
      </div>
    </div>
  );
};

export default connect((state) => state, actions)(ExpertDemeanorList);
